import React from "react";
import get from "lodash/get";
import { object, string } from "prop-types";

import CustomStoryCard2 from "../../../molecules/CustomStoryCard2";

import "./organism1.m.css";

const Organism1 = ({ collection, captionStyle = "" }) => {
  if (!(collection && collection.items && collection.items.length)) {
    return null;
  }
  const showRightImageListOption = get(collection, ["associated-metadata", "show_list_for_mobile"], null);

  const stories = collection.items.filter(item => item.type === "story").map(item => item.story);
  if (!(stories && stories.length)) {
    return null;
  }
  const numberOfStories = get(collection, ["associated-metadata", "number_of_stories_to_show"], 12);
  const storyList = stories.length > 0 ? stories.slice(0, numberOfStories) : [];

  return (
    <div styleName={showRightImageListOption ? "list-view" : "story-container"}>
      {storyList.map((story, index) => (
        <CustomStoryCard2
          key={index}
          story={story}
          headlineType={18}
          subHeadlineType={6}
          isImageCaptionRequired={false}
          isSection={true}
          className="story"
          widths={[300]}
          isExcerpt={true}
          isMetaDataShown={false}
          captionStyle={captionStyle}
          updatedFont={true}
          src="12-stories-1ad-1widget"
          updateSubHeadline={true}
          updateSectionFont={true}
        />
      ))}
    </div>
  );
};

Organism1.propTypes = {
  collection: object.isRequired,
  captionStyle: string
};

export default Organism1;
